// サポートサイトのURL組み立てに使う共通部分。
//
// ドメインはハードコードせず、既存のサポートサイトリンク（HelpDrawer等）と同じ
// FLAGXS_SUPPORT_SITE_URLから取る。本番とデモ/staging等でドメインが異なるため
// （本番はflagxs-support.com、それ以外はsevend-support.net）、ハードコードすると
// 環境ごとの設定を無視してしまう。パス部分は各環境で共通の想定。

// 環境変数の値は末尾スラッシュ有無が揺れるため、結合前に正規化する。
export const SUPPORT_SITE_BASE_URL = (
  process.env.FLAGXS_SUPPORT_SITE_URL ?? ''
).replace(/\/+$/, '')

const BASIC_OPERATIONS_PATH = `${SUPPORT_SITE_BASE_URL}/product-how-to/basic-operations-of-flagxs`

// 複数画面から参照されるカテゴリのみ定数化する。1画面しか使わないパスは
// その画面の定義ファイル側で組み立ててよい。
export const PROJECT_PLAN_PREPARATION_PATH = `${BASIC_OPERATIONS_PATH}/project-plan-preparation`
export const SCREEN_LAYOUT_PATH = `${BASIC_OPERATIONS_PATH}/understanding-the-screen-layout`
